import gql from 'graphql-tag';

export default gql`
mutation CompetencyDocumentItemUpdate(
  $documentId: UUID!,
  $documentItemId:UUID!,
  $abbreviatedStatement: String,
  $fullStatement: String,
  $humanCodingScheme: String
) {
  CompetencyDocumentItemUpdate (input: {
    documentId: $documentId,
    id: $documentItemId,
    abbreviatedStatement: $abbreviatedStatement,
    fullStatement: $fullStatement,
    humanCodingScheme: $humanCodingScheme,
  }) {
    documentItem {
      id
      documentId
      abbreviatedStatement
      fullStatement
      humanCodingScheme
      createdAt
      modifiedAt
    }
  }
}
`;
